module.exports = __webpack_public_path__ + "media/images/country_flags/ye-92a3dd9c44a1a0428bed81315a4e1964.png";